import React from 'react';
import { useSelector } from 'react-redux';
import Modal from './Modal';
const ControllModal = props => {
    const modal = useSelector(state => state.site.modal);
    if (modal) {
        return (
            <Modal />
        );
    } else {
        return <></>;
    }
}

export default ControllModal;